// extracted by mini-css-extract-plugin
module.exports = {"root":"DatePickerCustom_root__v0osf","footer":"DatePickerCustom_footer__3QeMK"};